import React from "react";

const AdminDashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard Home</h1>
    </div>
  );
};

export default AdminDashboard;
